import { IDocumentos, IEmpresas } from '@/types';

export interface IFiltroLocal {
  empresas: string[]
  periodo: string,
  documentos: string[],
  i: number | string,
  incluirHoje?: boolean
  dataFilterTemp? : Object,
  tipoValorSelecionado: number | string
}

export interface IItemDashboard {
  id: number
  updatedName: string
}

export interface IDashboardState {
  nome: string
  key: string;
  layout: ILayout;
  i: number;
  isLoggedUserAuthor: boolean;
}

export interface ILayout {
  agruparPor: string
  h: number,
  i: number | string,
  label: string,
  maxH: number,
  maxW: number,
  minH: number,
  minW: number,
  moved: boolean,
  reference: string,
  static: boolean,
  tipo: string,
  w: number,
  x: number,
  y: number
}

export interface IFiltros {
  documentos: string[]
  tipoValorSelecionado: string | number;
  empresas: string[]
  i: number | string
  periodo:string
}

export interface IDashboard {
  id?: number
  title: string
  key: string
  layout: ILayout[]
  isDefault: boolean
  rolesAuthorizedToView?:string[],
  rolesAuthorizedToEdit?:string[],
  isDefaultDashboard?: boolean,
  isSelectedToViewByDefault?: boolean,
}

export interface IBDashboard {
  dashboardName: string;
  dashboardId: string;
  layout?:[];
  isDefault?: boolean;
  rolesAuthorizedToView?:string[];
  rolesAuthorizedToEdit?:string[];
  isDefaultDashboard: boolean;
  isSelectedToViewByDefault: boolean;
  userRoleId: string;
  userId: string;
  isLoggedUserAuthor: boolean;
}

export interface DashboardState {
  dashboardList: IDashboard[]
  currentDash: string
  currentDashboardName: string
  isEditorMode: boolean
  isEditar: boolean
  shotcutDate: Object
  gridLayoutEditor: ILayout[]
  empresasOptions: IEmpresas[]
  filtrosLocaisPreenchidos: IFiltroLocal[]
  tipoDeDocumento: IDocumentos[]
}

export interface IMenuItemProps {
  label: string
  tipo: string
  agruparPor: string
  reference: string
}

export interface IDragEndProperties {
  h: number
  i: number | string
  w: number
  x: number
  y: number
}

export interface IElementSize {
  minW: number
  minH: number
  w: number
  h: number
  maxW: number
  maxH: number
}

export interface IWidgetsTypes {
  chart: IElementSize
  card: IElementSize
  panel: IElementSize
}

export enum Widgets {
  card= 'card',
  chart = 'chart',
  table = 'table',
  panel = 'panel'
}

export interface IItemsProperties {
  agruparPor?: string
  h?: number
  i: number
  label: string
  maxH?: number
  maxW?: number
  minH?: number
  minW?: number
  moved?: boolean
  reference: string
  static?: boolean
  tipo?: string
  w?: number
  x: number
  y: number,
  isMax?: boolean

}

export enum DashboardMutations {
  ATUALIZAR_LISTA_DASHBOARD = 'ATUALIZAR_LISTA_DASHBOARD',
  ATUALIZAR_LISTA_MODIFICACOES_DASHBOARD = 'ATUALIZAR_LISTA_MODIFICACOES_DASHBOARD',
  ATUALIZAR_LISTA_MODIFICACOES_DASHBOARD_ITENS = 'ATUALIZAR_LISTA_MODIFICACOES_DASHBOARD_ITENS',
  OPEN_EDITOR_MODE = 'ABRIR_MODO_EDITOR',
  CLOSE_EDITOR_MODE = 'FECHAR_MODO_EDITOR',
  ATUALIZAR_GRID_LAYOUT_EDITOR = 'ATUALIZAR_GRID_LAYOUT_EDITOR',
  ATUALIZAR_NOME_DASHBOARD_ATUAL = 'ATUALIZAR_NOME_DASHBOARD_ATUAL',
  ATUALIZAR_DASHBOARD_SELECIONADA = 'ATUALIZAR_DASHBOARD_SELECIONADA',
  ATUALIZAR_LISTA_EMPRESAS_OPTIONS = 'ATUALIZAR_LISTA_EMPRESAS_OPTIONS',
  ATUALIZAR_LISTA_FILTROS_LOCAIS_PREENCHIDOS= 'ATUALIZAR_LISTA_FILTROS_LOCAIS_PREENCHIDOS',
  ATUALIZAR_IS_EDITAR = 'ATUALIZAR_IS_EDITAR',
  LIMPAR_LISTA_MODIFICACOES = 'LIMPAR_LISTA_MODIFICACOES',
  LISTA_INICIAL = 'LISTA_INICIAL',
  ATUALIZAR_LAYOUT = 'ATUALIZAR_LAYOUT',
  ATUALIZAR_LISTA_APOS_EXCLUIR = 'ATUALIZAR_LISTA_APOS_EXCLUIR',
  ATUALIZAR_TIPO_DE_DOCUMENTO = 'ATUALIZAR_TIPO_DE_DOCUMENTO',
  SALVAR_SHORTCUTDATAS = 'SALVAR_SHORTCUTDATAS'
}

export enum DashboardActions {
  ATUALIZAR_NOME_ITEM_DASHBOARD = 'ATUALIZAR_NOME_ITEM_DASHBOARD',
  SALVAR_DASHBOARD = 'SALVAR_DASHBOARD',
  REMOVER_DASHBOARD = 'REMOVER_DASHBOARD',
  ADICIONAR_FILTRO_LOCAL = 'ADICIONAR_FILTRO_LOCAL',
  REMOVER_FILTRO_LOCAL = 'REMOVER_FILTRO_LOCAL',
  ATUALIZAR_DASHBOARD_PADRAO = 'ATUALIZAR_DASHBOARD_PADRAO',
  SALVAR_DASHBOARD_EDITMODE = 'SALVAR_DASHBOARD_EDITMODE'
}

export enum DashboardGetters {
  FIND_ITEM_GRID_LAYOUT = 'FIND_ITEM_GRID_LAYOUT',
  FIND_DASHBOARD = 'FIND_DASHBOARD',
  FIND_LAYOUT_BY_CURRENT_DASH = 'FIND_LAYOUT_BY_CURRENT_DASH',
  FIND_LOCAL_FILTER = 'FIND_LOCAL_FILTER',
  IS_CURRENT_DEFAULT_DASHBOARD = 'IS_CURRENT_DEFAULT_DASHBOARD',
  FIND_DEFAULT_DASHBOARD = 'FIND_DEFAULT_DASHBOARD',
  FIND_DASHBOARD_BY_ID = 'FIND_DASHBOARD_BY_ID',
}
